import { chartColors } from './chartColors';

export const getDonutOptions = ({ series, labels }) => ({
  chart: {
    type: 'donut',
    height: 320,
  },
  dataLabels: {
    enabled: true,
    style: {
      fontSize: '20px',
    },
  },
  labels,
  series,
  legend: {
    show: true,
    position: 'bottom',
    horizontalAlign: 'center',
    floating: false,
    fontSize: '14px',
    offsetY: 7,
  },
  colors: chartColors,
  responsive: [
    {
      breakpoint: 600,
      options: {
        chart: {
          height: 240,
        },
        legend: {
          show: true,
        },
      },
    },
  ],
});
